/*
 * @Author: jake
 * @Date: 2019-01-20 11:53:58
 * @Last Modified by: jake
 * @Last Modified time: 2020-02-18 14:12:36
 * 统计封装
 */
const Stat = {}
Stat.install = function (Vue, options = {}) {
  const { app='',appId='h575a829da88f34f02',version='1.0.0' } = options
  class Stat extends Vue {
    constructor() {
      super()
      this.statData = []
      this.extendValue = {}
    }

    setExtend(extend) {
      if (extend) {
        this.extendValue = extend
      }
    }
    rmExtend() {
      this.extendValue = {}
    }

    pageLoadStat(data = {}) { // 页面加载统计
      let {
        operation = null,
        relatedType = null,
        triggerAction = 'PV'
      } = data
      const route = this.$helper.getRoute()
      const json = {
        'module': route, // 页面名称
        'operation': operation, // 操作东西名称
        'relatedType': relatedType, // 事件类型
        'triggerAction': triggerAction // 动作的目的
      }
      this.statData.push(json)
      this.sendStat()
    }

    commonStat({
      operation,
      relatedType,
      triggerAction
    }) { // 通用统计
      const route = this.$helper.getRoute()
      const json = {
        'module': route, // 页面名称
        'operation': operation, // 操作东西名称
        'relatedType': relatedType, // 事件类型
        'triggerAction': triggerAction // 动作的目的
      }
      this.statData.push(json)
    }

    sendStat(res = {}) {
      const { // 发送当前统计
        succ,
        fail
      } = res
      if (this.statData.length <= 0) {
        return
      }
      this.$request.getToken({
        succ: (res) => {
          this.statData.map((item, index) => {
            if (item.create_time) {
              this.sendStatData(item)
            }
          })

          this.statData = []
        },
        fail: () => {

        }
      })
    }

    savePageShare({ // 页面分享统计
      title,
      page,
      menu_share = '',
      shareSuccess,
      succ = function () { },
      fail = function () { }
    }) {
      this.$request.httpRequest({
        path: '/action/savePageShare',
        data: {
          row: {
            title,
            page,
            menu_share,
            share_success: shareSuccess,
            app: app
          }
        },
        method: 'POST',
        succ: succ,
        fail: fail,
        platformKey: 'api',
        baseURL: this.$env.api,
        isEncode: false
      })
    }

    getAppSharePageConfig({
      module,
      operation,
      relatedType,
      triggerAction
    } = {}) {
      const route = this.$helper.getRoute()
      let stat = {}
      if (!this.shareWordDetail || !this.shareWordDetail[route]) {
        stat = { title: '多保鱼选保险', imageUrl: 'https://www.91duobaoyu.com/static/res/src/images/weixin.jpg' }
        // stat = {title: '多保鱼选保险', imageUrl: this.$env.static+'/weixin.jpg'}
      } else {
        stat = this.shareWordDetail[route]
        stat.imageUrl = stat.imgUrl
        stat.path = stat.shareUrl
      }
      const title = stat.title
      const json = {
        'module': module || route, // 页面名称
        'operation': operation || '', // 操作东西名称
        'relatedType': relatedType || '', // 事件类型
        'triggerAction': triggerAction || 'share' // 动作的目的
      }
      this.statData.push(json)
      this.sendStat()
      return {
        path: route,
        ...stat
      }
    }

    getAppShareConfig(data = {}) { // 获取当前分享初始化配置
      let {
        succ = function () { },
        fail = function () { }
      } = data
      const s = res => {
        const shareWordDetail = res.data.dbydata.shareWordDetail
        this.shareWordDetail = shareWordDetail
        succ()
      }
      const f = res => {
        fail()
      }
      this.$request.httpRequest({
        path: '/pageShare/getAllPageShareWord',
        method: 'POST',
        succ: s,
        fail: f,
        platformKey: 'api',
        baseURL: this.$env.api
      })
    }

    send(data) {
      return new Promise((resolve, reject) => {
        this.$user.getUserInfo().then((result) => {
          data.unionid = result.unionId
          this.sendStatData(data).then((res) => {
            resolve(res)
          }).catch((err) => {
            reject(err)
          })
        }).catch((err) => {
          reject(err)
        })
      })

    }

    // 新埋点接口
    sendStatData(data = {}) {
      let {
        id = this.uuid(),
        // 创建时间
        create_time = this.$helper.getTime('YYYY-MM-DD HH:mm:ss'),
        // 小程序id
        client_id = appId,
        // 小程序版本
        client_version = version,
        // 用户id
        unionid = null,
        user_id = null,
        // 会话id
        connection_id = this.uuid(),
        // 事件类型
        action_id = null,
        // 页面url
        url = window.location.href,
        // 按钮名
        button_name = null,
        // btnid
        button_id = null,
        // 停留时间
        stay_time = null,
        // 行为类型
        action_type = null,
        log_type = null,
        pre_view_id = document.referrer,
        current_view_id = window.location.pathname,
        mobile_id = '',
        os_version = '',
        language = 'zh-cn',
        resolution_ratio = '',
        utd_id = null,
        // 其他
        extend_01 = null,
        extend_02 = null,
        extend_03 = null,
        extend_04 = null,
        source_id = app
      } = data
      let json = {
        'id': id,
        'create_time': create_time,
        'client_id': client_id,
        'client_version': client_version,
        'user_id': user_id || unionid,
        'connection_id': connection_id,
        'action_id': action_id,
        'url': url,
        'button_name': button_name,
        'button_id': button_id,
        'stay_time': stay_time,
        'action_type': action_type,
        'log_type': log_type,
        'pre_view_id': pre_view_id,
        'current_view_id': current_view_id,
        'mobile_id': mobile_id,
        'os_version': os_version,
        'language': language,
        'resolution_ratio': resolution_ratio,
        'utd_id': utd_id,
        'extend_01': extend_01,
        'extend_02': extend_02,
        'extend_03': extend_03,
        'extend_04': extend_04,
        'source_id': source_id,
        ...this.extendValue
      }
      return new Promise((resolve, reject) => {
        this.$request.post({
          path: '/event/upload',
          baseURL: 'https://point.91duobaoyu.com/webtrack',
          data: json
        }).then((res) => {
          resolve(res)
        }).catch((err) => {
          reject(err)
        })
      })
    }

    // 生成一串随机id
    uuid() {
      var s = []
      var hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'

      var uuid = s.join('')
      return uuid
    }

    // 记录请求顺序
    setStatOrder() {
      let value = localStorage.getItem('statOrder')
      if (value >= 10000) {
        value = null
      }
      if (!value) {
        localStorage.setItem('statOrder', 1)
      } else {
        localStorage.setItem('statOrder', Number(value) + 1)
      }
      return localStorage.getItem('statOrder')
    }
  }
  Vue.prototype.$stat = new Stat()
}
export default Stat
